import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
interface ProtectedRouteProps {
  children: React.ReactNode
  roles?: string[]
  resource?: string
  action?: string
  /** Capability slug(s) resolved via the admin-assignable capability system
   * (role default + per-user grants/revokes), unlike `roles` which is a
   * hardcoded job-title list. Prefer this for financial/workflow routes. */
  capability?: string | string[]
  fallback?: React.ReactNode
}

export default function ProtectedRoute({
  children,
  roles,
  resource,
  action = 'read',
  capability,
  fallback
}: ProtectedRouteProps) {
  const { hasRole, canAccess, hasCapability } = usePermissions()

  // Check role-based access
  if (roles && !hasRole(roles)) {
    return fallback || <Navigate to="/dashboard" replace />
  }

  // Check resource-based access
  if (resource && !canAccess(resource, action)) {
    return fallback || <Navigate to="/dashboard" replace />
  }

  // Check capability-based access
  if (capability && !hasCapability(capability)) {
    return fallback || <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
